<template>
  <v-form ref="form" @submit="Login">
    <v-card class="elevation-12">
      <v-card-title primary-title class="primary">
        <div class="headline white--text">Login</div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          autocomplete="username"
          prepend-icon="person"
          name="username"
          label="Username"
          :disabled="loading"
          v-model="user.username"
          type="text">
        </v-text-field>
        <v-text-field
          autocomplete="current-password"
          id="password"
          prepend-icon="lock"
          name="password"
          label="Password"
          :disabled="loading"
          v-model="user.password"
          type="password">
        </v-text-field>
        <router-link :to="{ name: 'SignUp' }">Register</router-link>&nbsp;
        <router-link :to="{ name: 'ForgotPassword' }">Forgot password?</router-link>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          type="submit"
          color="primary"
          :loading="loading"
          @click="Login">
          Login
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'SignIn',
  data() {
    return {
      loading: false,
      user: {
        username: null,
        password: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      username: 'auth/username',
    }),
  },
  methods: {
    ...mapActions({
      signIn: 'auth/signIn',
    }),
    Login(e) {
      e.preventDefault();
      this.loading = true;
      this.signIn(this.user)
        .then((res) => {
          this.loading = false;
          console.log(res);
          if (res && res.challengeName === 'NEW_PASSWORD_REQUIRED') {
            this.$router.push({ name: 'CompleteNewPassword' });
          } else {
            this.$router.push({ name: 'Dashboard' });
          }
        });
    },
  },
  mounted() {
    if (this.username) {
      this.user.username = this.username;
    }
  },
};
</script>

<style scoped>
</style>
